<template>
  <div>
    <div class="header__page">
      <h1>Подразделения</h1>

      <div class="buttons">
        <Button
          v-show="!hasVisibleActionForDeleted"
          text="Создать"
          icon="addFile"
          width="100%"
          iconWidth="15px"
          class="buttons__item"
          @click="createDepartment()"
        />
        <Button
          v-show="hasVisibleAction && !hasVisibleActionForDeleted"
          text="Редактировать"
          icon="edit"
          width="100%"
          iconWidth="15px"
          class="buttons__item"
          @click="editDepartment()"
        />
        <Button
          v-show="hasVisibleAction  && !hasVisibleActionForDeleted"
          text="Удалить"
          icon="delete"
          width="100%"
          iconWidth="15px"
          class="buttons__item"
          @click="deleteDepartment()"
        />
        <Button
            v-show="hasVisibleActionForDeleted && !hasVisibleRecover"
            text="Восстановить"
            icon="user_restore"
            width="100%"
            iconWidth="15px"
            class="buttons__item"
            @click="restoreDepartment()"
        />
      </div>
    </div>
    <VSwitch v-model="isTrashed" label="Показать удалённые" @valueChange="getTrashedItems" />

    <div class="departments">
      <Preloader v-if="treeDepartmentsLoading" />

      <Subdivision
        v-show="!treeDepartmentsLoading"
        v-for="(dep, i) of tree"
        :key="i"
        :node="dep"
        :isActiveId="isActiveId"
        routeName="SaveDepartmentUpdate"
        @highlightField="highlightField"
        @outsideHandler="outsideHandler"
      />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import Subdivision from "@/components/Subdivision.vue";
import Preloader from "@/components/Preloader.vue";
import {mapState, mapActions, mapGetters} from "vuex";
import {deleteDepartment, restoreDepartment} from "@/api/departments";
import VSwitch from "@/components/VSwitch.vue";

function searchNode (tree, value, key = 'id') {
  while (tree.length) {
    const node = tree.shift()
    if (node[key] === value) {
      return node
    }
    node.children && tree.push(...node.children)
  }
  return null
}

export default {
  name: "Departments",
  components: {
    VSwitch,
    Subdivision,
    Preloader,
    Button
  },
  mounted() {
    !this.tree.length && this.getTreeDepartments({ trashed: this.isTrashed });
  },
  destroyed() {
    // this.$store.commit('departments/CLEAR_TREE_DEPARTMENTS')
  },

  data() {
    return {
      currentField: null,
      isActiveId: null,
      isTrashed: false
    };
  },

  computed: {
    ...mapState("departments", ["treeDepartmentsLoading"]),
    ...mapGetters({
      tree: "departments/treeDepartments"
    }),

    hasVisibleAction () {
      return !!this.currentField?.id
    },
    hasVisibleActionForDeleted () {
      return !!this.currentField?.deleted_at
    },
    hasVisibleRecover () {
      const node = searchNode([...this.tree], this.currentField?.parent_id)
      return !!node?.deleted_at
    }
  },
  methods: {
    ...mapActions("departments", ["getTreeDepartments", "setActiveEl"]),

    outsideHandler () {
      this.currentField = null
      this.highlightField(null)
    },

    highlightField (node) {
      this.isActiveId = node?.id
      this.currentField = { ...node }
    },

    createDepartment () {
      if (this.currentField?.id) {
        this.$router.push({ name: 'SaveDepartmentCreate', params: { node: this.currentField } })
      } else {
        this.$router.push({ name: 'SaveDepartmentCreate' })
      }
    },

    editDepartment () {
      const node = this.currentField
      this.$router.push({ name: 'SaveDepartmentUpdate', params: { node, id_department: node.id } })
    },

    deleteDepartment() {
      const deleteDepFunc = () =>
          deleteDepartment(this.currentField?.id)
              .then(() => {
                this.getTreeDepartments({ trashed: this.isTrashed });
              })
              .finally(() => {
                this.outsideHandler()
              });

      this.$root.confrim(
        "Вы точно хотите удалить это подразделение?",
        deleteDepFunc,
        "Да"
      );
    },

    restoreDepartment() {
      const restoreDepFunc = () =>
          restoreDepartment(this.currentField?.id)
              .then(() => {
                this.getTreeDepartments({ trashed: this.isTrashed });
              })
              .finally(() => {
                this.outsideHandler()
              });

      this.$root.confrim(
          "Вы точно хотите восстановить это подразделение?",
          restoreDepFunc,
          "Да"
      );
    },

    getTrashedItems () {
      this.getTreeDepartments({ trashed: this.isTrashed });
    }
  },
};
</script>

<style lang="scss" scoped>
.departments {
  background: #f1f6f9;
  margin-top: 24px;
  border-radius: 4px;
  padding: 36px 34px;
  overflow: auto;
  width: 100%;
  height: auto;
  min-height: calc(100vh - 365px);

  @media screen and (max-width:1500px) {
    padding: 32px;
  }
}
</style>
